export enum FieldType {
	Name = 'Name',
	Author = 'Author',
	Questions = 'Questions',
	Created = 'Created',
}
